import { EventHandler, GameController, GameState } from "../engine/GameController.ts";

const gameController = new GameController();
export const useGameController = () => {
    return gameController;
  };
  
